import { Wrapper } from "./styles";

export const CardCVV = ({ CVV }: { CVV: string }) => {
    return <Wrapper>{CVV}</Wrapper>;
};
